<template>
  <div id="app" v-if="isPay">
    <div v-if="isLogin">
      <top-header v-if="topShow" />
      <div :class="topShow ? 'mainBg' : 'mainBgNo'">
        <left-menu v-if="leftMenuShow" />
        <router-view v-if="leftMenuShow" class="routerview left250" />
        <router-view v-else class="routerview left0" />
      </div>
    </div>
    <router-view v-else class="routerview left0" />
  </div>
  <div v-else id="app_h5">
    <router-view class="routerview_h5" />
  </div>
</template>

<script>
import TopHeader from "@/components/TopHeader";
import LeftMenu from "@/components/LeftMenu";
import { mapState, mapActions } from "vuex";

export default {
  name: "App",
  components: {
    TopHeader,
    LeftMenu,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      leftMenuShow: "leftMenuShow",
    }),
    isLogin() {
      return this.$route.path !== "/userlogin";
    },
    isPay() {
      return (
        this.$route.path !== "/pay" &&
        this.$route.path !== "/personaldetails" &&
        this.$route.path !== "/video" &&
        this.$route.path !== "/wxspacedetails" &&
        this.$route.path !== "/wxsweep" &&
        this.$route.path !== "/updaterecord" &&
        this.$route.path !== "/oauthapply" &&
        this.$route.path !== "/useragreement" &&
        this.$route.path !== "/sweep"
      );
    },
    topShow() {
      return this.$route.path.toLowerCase() != "/spacedetails";
    },
  },

  methods: {
    ...mapActions({
      getLoginInfo: "UserLogin/getLoginInfo",
    }),
  },

  created() {
    let path = this.$route.path.toLowerCase();
    // 获取用户登录信息
    if (
      !path.startsWith("/userlogin") &&
      !path.startsWith("/pay") &&
      !path.startsWith("/personaldetails") &&
      !path.startsWith("/wxspacedetails") &&
      !path.startsWith("/wxsweep") &&
      !path.startsWith("/updaterecord") &&
      !path.startsWith("/oauthapply") &&
      !path.startsWith("/useragreement")
    ) {
      this.getLoginInfo();
    }
  },
};
</script>

<style lang="stylus">
@import './assets/stylus/base.styl';
@import './assets/stylus/customI.styl';
@import './assets/stylus/customII.styl';

html, body {
  width: 100%;
  height: 100%;
}

#app_h5 {
  width: 100%;
  height: 100%;

  .routerview_h5 {
    width: 100%;
    height: 100%;
  }
}

#app {
  width: 100%;
  height: 100%;
  min-width: 1920px;
  margin: 0 auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .mainBg {
    position: absolute;
    left: 0;
    top: 80px;
    right: 0;
    bottom: 0;

    .left250 {
      left: 250px;
    }

    .left0 {
      left: 0;
    }

    .routerview {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      min-width: 1670px;
      padding: 30px 30px 0 30px;
      box-sizing: border-box;
      min-height: 600px;
      background: #E9ECF3;
    }
  }

  .mainBgNo {
    position: absolute;
    left: 0;
    top: 0px;
    right: 0;
    bottom: 0;

    .left250 {
      left: 250px;
    }

    .left0 {
      left: 0;
    }

    .routerview {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      min-width: 1920px;
      box-sizing: border-box;
      height: 100%;
      background: #E9ECF3;
    }
  }

  .el-pagination.right {
    float: right;
    margin-top: 20px;
  }
}

.dialogFrom {
  text-align: center;

  .el-dialog {
    text-align: left;
    display: inline-block;
    vertical-align: middle;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .el-dialog__header {
    padding: 10px 0;
    border-bottom: 1px solid #e6e6e6;
    text-indent: 30px;

    .el-dialog__title {
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000;
      line-height: 60px;
    }
  }

  .el-dialog__body {
    padding: 10px;
  }
}

.dialogFrom::after {
  content: '';
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: middle;
}

.el-table .cell {
  font-weight: 400;
  color: #040300;
}

// 调整蓝色按钮颜色
.el-button--primary {
  color: #FFF;
  background-color: #3A81FF;
  border-color: #3A81FF;
}

.el-button--primary.is-plain {
  color: #3A81FF;
  background: #F7FAFF;
  border-color: #3A81FF;
}

.el-button--primary.is-plain:hover {
  color: #FFF;
  background-color: #3A81FF;
  border-color: #3A81FF;
}
</style>




// WEBPACK FOOTER //
// src/App.vue